import React from "react";
import { Routes, Route } from "react-router-dom";
import FormsListing from "./formsListing";
import EditForm from "./editForm";
const FormsLibrary = () => {
  return (
    <Routes>
      <Route path="/" element={<FormsListing />} />
      <Route path="/:id" element={<FormsListing />} />
      <Route path="/:id/form/:form_id" element={<EditForm />} />
      
    </Routes>
  );
};

export default FormsLibrary;
